<div mat-dialog-title class="dialog-title p-3 pr-5">
  <h5>Filter Tasks</h5>
  <button
    mat-icon-button
    aria-label="Close dialog"
    matTooltip="Close this dialog."
    mat-dialog-close
    class="dialog-close-button">
    <mat-icon>close</mat-icon>
  </button>
</div>

<hr class="m-0 p-0">

<mat-dialog-content class="filter-content d-flex m-0 pt-4 pb-2 flex-wrap" style="justify-content: space-evenly">

  <ng-container matColumnDef="sites">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectSites()"
        [matBadge]="'' + (filters.site_ids.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>location_on</mat-icon> {{ utils.getLangTerm('parent-child-sites-combined.plural', 'Sites') }}
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="users">
    <div style="padding: 5px !important;">
      <button
        mat-raised-button
        type="button"
        (click)="onSelectUsers()"
        [matBadge]="'' + (filters.assigned_users.length || 'All')"
        class="mx-3 mt-2">
        <mat-icon>account_circle</mat-icon> Assigned Users
      </button>
    </div>
  </ng-container>

  <ng-container matColumnDef="priority">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 110px;">
        <mat-label>Priority</mat-label>
        <mat-select
          placeholder="Priority"
          [(ngModel)]="filters.priority"
          name="priority"
          matTooltip="Filter records by Priority">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let priority of priorities" [value]="priority">
            {{priority}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="status">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 120px;">
        <mat-label>Status</mat-label>
        <mat-select
          placeholder="Status"
          [(ngModel)]="filters.status"
          name="status"
          matTooltip="Filter records by Status">
          <mat-option value="">All</mat-option>
          <mat-option value="0">Open</mat-option>
          <mat-option value="1">Completed</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="origin">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 180px;">
        <mat-label>Origin</mat-label>
        <mat-select
          placeholder="Origin"
          [(ngModel)]="filters.origin"
          name="origin"
          matTooltip="Filter records by Origin">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let origin of origins" [value]="origin">
            {{origin}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="type">
    <div style="padding: 5px !important;">
      <mat-form-field class="mx-3 mt-2" appearance="outline" subscriptSizing="dynamic" style="width: 270px;">
        <mat-label>Type</mat-label>
        <mat-select
          placeholder="Type"
          [(ngModel)]="filters.type"
          name="type"
          matTooltip="Filter records by Type">
          <mat-option value="">All</mat-option>
          <mat-option *ngFor="let type of types" [value]="type">
            {{type}}
          </mat-option>
        </mat-select>
      </mat-form-field>
    </div>
  </ng-container>

  <ng-container matColumnDef="date_range">
    <div style="padding: 0 1px !important;">
      <app-date-range-picker dateRangeTitle="Due Date" dateRangePlaceholder="Select Due Date Range" dateRangeTooltip="Filter Tasks Due Date by date range." [dateRangeInput]="filters.date_range" (dateRangeOutput)="getOutputDateRange($event)"></app-date-range-picker>
    </div>
  </ng-container>

</mat-dialog-content>

<hr class="m-0 p-0">

<mat-dialog-actions class="d-flex flex-wrap justify-content-center my-2 py-2">
  <ng-container matColumnDef="buttons">
    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="primary"
        (click)="onSaveAndClose()">
        <mat-icon>filter_list</mat-icon> Apply Filter
      </button>
    </div>

    <div class="p-2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearAndClose()">
        <mat-icon> clear_all</mat-icon> Clear Filter
      </button>
    </div>

    <div class="p-2" *ngIf="filters.date_range.length == 2">
      <button
        type="button"
        mat-raised-button
        color="secondary"
        (click)="onClearDateRange()">
        <mat-icon>clear</mat-icon> Clear Date Range
      </button>
    </div>
  </ng-container>
</mat-dialog-actions>




